import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import type { ComposeFileMenuContentProps } from './components/ComposeFileMenuContent';
import type { ReadPopoutFileMenuContentProps } from './components/ReadPopoutFileMenuContent';

export type { ReadPopoutFileMenuContentProps } from './components/ReadPopoutFileMenuContent';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "FileMenuContent" */ './lazyIndex'),
    { name: 'FileMenuContent' }
);

export const LazyFileMenuContent: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.FileMenuContent
);

export const LazyComposeFileMenuContent: LazyComponent<
    ComposeFileMenuContentProps,
    undefined,
    void
> = createLazyComponent<ComposeFileMenuContentProps, typeof lazyIndex, undefined /* TInnerRef */>(
    lazyModule,
    m => m.ComposeFileMenuContent
);

export const LazyReadPopoutFileMenuContent: LazyComponent<
    ReadPopoutFileMenuContentProps,
    undefined,
    void
> = createLazyComponent<
    ReadPopoutFileMenuContentProps,
    typeof lazyIndex,
    undefined /* TInnerRef */
>(lazyModule, m => m.ReadPopoutFileMenuContent);
